module.exports = __webpack_public_path__ + "static/media/borrower-v2-vector.cfab18d8.png";